import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAdmissions } from '../../../../store/actions/admissionsActions'
import Loader from '../../../../components/elements/Loader'
import EmptyState from '../../../../components/elements/EmptyState'
import { tableHeadersFields, transactionTimeStamp } from '../../../../utils'
import DataTable from '../../../../components/elements/DataTable'
import { useNavigate } from 'react-router-dom'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import { fetchAcademicSessions } from '../../../../store/actions/academicSessionsActions'
import NewAdmission from '../../../../components/partials/admissions/NewAdmission'
import { fetchFees } from '../../../../store/actions/feesActions'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'


const Admissions = () => {
  const dispatch = useDispatch()
  const admissionsSelector = useSelector((state => state.admissions))
  const navigate = useNavigate()
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    dispatch(fetchAdmissions())
    dispatch(fetchFees('', 0, 0))
    dispatch(fetchAcademicSessions('', 0, 0))
    return () => {
      
    };
  }, [page, perPage, dispatch, reload]);

  const tableOptions = {
    selectable: false,
    multiselect: false,
    clickableRows: true,
    rowAction: (rowIndex)=>{
      navigate(admissionsSelector.admissions.admissions[rowIndex]._id)
    }
  }

  const columnWidths = {
    title: 'w-3/12',
    startDate: 'w-2/12',
    endDate: 'w-2/12',
    classes: 'w-1/12',
    fee: 'w-1/12',
    session: 'w-2/12',
    status: 'w-1/12',
  }

  const columnDataStyles = {}

  const [creatingAdmission, setCreatingAdmission] = useState(false);
  
  const cleanUpTableData = (array) => {
    if(!array) return
    let finalResult = [] 
    array.forEach((object, objectIndex) => {
        const applicationObject = {
          // applicant: <ApplicantTableSnippet applicant={object} />,
          title: <div className='flex items-center gap-x-1'>
              {object.title} 
              <span className={`inline-block text-xs px-1 py-1 rounded font-outfit capitalize
                ${object.type === 'SUPPLEMENTARY' && 'bg-vcm-light-purple text-vcm-purple bg-opacity-20'}
                ${object.type === 'MAIN' && 'bg-blue-600 text-blue-800 bg-opacity-10'}
                `}>{object.type.toLowerCase()}
              </span>
            </div>,
          startDate: transactionTimeStamp(object.startDate).date,
          endDate: transactionTimeStamp(object.endDate).date,
          classes: object.entryClasses.join(', '),
          status: <span className={`inline-block text-xs px-2 py-1 rounded 
          ${!object.active && 'bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize'}
          ${object.active && 'bg-green-600 text-green-800 bg-opacity-10 font-outfit capitalize'}
          `}>{object.active ? 'Active' : 'Inactive'}</span>,
          session: object.academicSession?.name,
          fee: <span>₦{(object?.fee?.amount/100).toLocaleString()}</span>
        }

        finalResult.push(applicationObject)
    })
    return finalResult
  }

  return (
    <>
      <AdministrationLayout pageTitle={`Admissions/Openings`}>
        <div className='w-full'>
          <div className='w-full flex justify-between'>
            <div>
              <h3 className='text-lg font-medium'>Admissions/Openings</h3>
              <p className='text-sm'>All applications for admission to Vaatia College, Makurdi</p>
            </div>
            <div>
              <button onClick={()=>{setCreatingAdmission(true)}}  className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                <PlusIcon className='w-5 h-5' /> Create new Opening
              </button>

            </div>
          </div>

          {/* <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
            <div className='w-full'>
              <Filters filterOptions={filterOptions} />
            </div>
          </div> */}

          {admissionsSelector.loadingAdmissions ? 
            <Loader />
            :
            <>
              {admissionsSelector?.admissions?.admissions?.length > 0 ? <div className=''>
                <div className='w-full'>
                  <DataTable
                    tableHeaders={tableHeadersFields(cleanUpTableData(admissionsSelector.admissions.admissions)[0]).headers} 
                    tableData={cleanUpTableData(admissionsSelector.admissions.admissions)} 
                    columnWidths={columnWidths}
                    columnDataStyles={columnDataStyles}
                    allFields={tableHeadersFields(cleanUpTableData(admissionsSelector.admissions.admissions)[0]).fields}
                    onSelectItems={()=>{}}
                    tableOptions={tableOptions}
                    pagination={{
                        perPage, 
                        page,
                        totalItems: admissionsSelector.admissions.total,
                    }}
                    onSelectSingle={()=>{}}
                    changePage={setPage}
                    updatePerPage={setPerPage}
                  />
                </div>
              </div>
                : 
                <div className='mt-24 w-1/2 mx-auto'>
                  <EmptyState emptyStateText={`There are no applications yet!`} />
                </div>

              }
            </>
          }
        </div>
      </AdministrationLayout>

      <ModalDialog
        shown={creatingAdmission} 
        closeFunction={()=>{setCreatingAdmission(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Create a new admission`}
        dialogTitle='Create a new admission or opening'
        maxWidthClass='max-w-6xl'
        hideActions={true}
      >
        <NewAdmission
          reload={()=>setReload(reload+1)}
          closeFunction={()=>{setCreatingAdmission(false)}} 
        />
      </ModalDialog>
    </>
  )
}

export default Admissions